<div class="app-container">
  <app-search #searchComponent></app-search>
  <app-video-player [searchComponent]="searchComponent"></app-video-player>
  <footer class="app-footer">
    <div class="footer-content">
      <p class="author-line">with lust, by <a href="https://github.com/Bitz" target="_blank" rel="noopener noreferrer">Bitz</a> for Nami 💓</p>
      <p class="build-info">Built {{ formattedBuildDate }} • {{ shortHash }}</p>
    </div>
  </footer>
  
  <!-- Toast notifications -->
  <app-toast></app-toast>
</div>
